import * as msal from '@azure/msal-browser'
import { loginAAD } from '../../services/auth/loginAAD'
import store from '@/store'
import { me } from '@/services/auth/me'
import router from '@/router'

const state = () => ({
  clientID: undefined,
  tenantID: undefined,
  redirect: getBaseURL() + '/redirect' || undefined,
  msalConfig: undefined,
  GuidSSO: undefined,
})

const getters = {
  clientID: state => state.clientID,
  tenantID: state => state.tenantID,
  domain: state => state.domain,
  GuidSSO: state => state.GuidSSO
}
const mutations = {
  settingUPMsal (state) {
    const msalConfig = {
      auth: {
        clientId: state.clientID,
        authority: 'https://login.microsoftonline.com/'+state.tenantID,
        redirectUri: state.redirect,
        protocolMode: 'OIDC',
      }
    }
    state.msalConfig = msalConfig
  },
  setClientID (state, value) {
    state.clientID = value
  },
  setTenantID (state, value) {
    state.tenantID = value
  },
  setGuidSSO (state, value) {
    state.GuidSSO = value
  },
}

const actions = {
  async showPopUpLogin ({ state }) {
    const msalInstance = await new msal.PublicClientApplication(state.msalConfig)
    const request = await msalInstance.loginPopup()
    // console.log(request.idToken)
    const payload = {
      B64Login: btoa(request.idToken),
      Guid: state.GuidSSO,
    }
    const data = await loginAAD(payload)
    if (data.blnError === true) {
      throw data
    } else {
      store.commit('auth/setTokens', {
        accessToken: data.Token,
        refreshToken: data.RefreshToken
      })
      // commit('setUser', null)
      const user = await me(data.Usuario)
      if (user.blnError === true) {
        throw user
      } else {
        store.commit('auth/setUser', user.respuesta)
      }
      store.commit('auth/setUsername', user.respuesta)
      router.push({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN })
      store.dispatch('auth/getModules')
      store.dispatch('auth/getPermisos')
      store.dispatch('app/getAnnouncementsList')
      await store.dispatch('app/getColors')
      store.dispatch('app/updateFrontColors')
    }
  },
}

function getBaseURL () {
  return window.location.origin
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
